import React from "react";

import { startCase } from "lodash";

import { useAuthenticationContext } from "@context/authentication";
import { InternalRoles, Role } from "@roles";

export const UserDisplay = () => {
  const { auth } = useAuthenticationContext();

  const groups = auth?.userGroups as Role[];

  const isInternalUser = groups.filter((group) => InternalRoles.includes(group)).length > 0;

  return (
    <>
      <h4>{startCase(`${auth?.currentUserData?.first_name || ""} ${auth?.currentUserData?.last_name || ""}`)}</h4>
      {!isInternalUser && <h6>{auth?.currentUserData?.participant?.company_name || ""}</h6>}
    </>
  );
};
